<template>
  <div class="page-container">
    <page-header></page-header>
    <page-table ref="table" show-paginate :get-data="videoLogPage" :fields="fields" :search-model="searchModel"
                :item-actions="actions" @onActionClick="handleItemActionClick">
      <template slot="search-items">
        <el-form-item label="类型" prop="device_type">
          <el-input v-model="searchModel.device_type" placeholder="类型"></el-input>
        </el-form-item>
      </template>
      <template slot="page-actions">
        <el-button @click="handleAdd" icon="el-icon-plus" size="mini" type="primary">上传视频/图片</el-button>
      </template>
    </page-table>
    <el-dialog title="上传视频/图片" :visible.sync="show_form_dialog" append-to-body
               :close-on-click-modal="false" custom-class="min-w-800">
      <el-form :model="formData" :rules="formRules" label-width="120px" ref="formData"
               v-loading="form_loading">
        <el-form-item label="类型" prop="device_type">
          <el-select v-model="formData.device_type">
            <el-option label="bus" value="bus"></el-option>
            <el-option label="car" value="car"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频/图片文件" prop="video_url">
          <el-upload
            class="upload-demo"
            drag
            action="-" accept="video/mp4,image/*" :http-request="handleUploadVideo" :show-file-list="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">
              <p>只能上传mp4、图片文件，且不超过200M</p>
              <p><el-link v-if-="formData.video_url">{{ formData.video_url }}</el-link></p>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频/图片名称" prop="video_name">
          <el-input placeholder="视频名称" v-model="formData.video_name"></el-input>
        </el-form-item>
        <el-form-item label="视频/图片时间" prop="time_range">
          <el-date-picker
            @change="timeRangeChange"
            v-model="formData.time_range"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间">
          </el-date-picker>

        </el-form-item>
        <div class="dialog-footer">
          <el-button @click="show_form_dialog = false">取消</el-button>
          <el-button type="primary" @click="addSubmit('formData')">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader"
import PageTable from "@/components/PageTable"
import {videoLogPage, videoLogCreate} from "@/api/sensor"
import {uploadImage, uploadVideo} from "@/api/common";

export default {
  name: "VideoLogs",
  data() {
    return {
      searchModel: {
        device_type: '',
      },
      videoLogPage: videoLogPage,
      fields: [
        {label: '#', key: 'id', sortable: true, width: 80},
        {label: '类型', key: 'device_type', width: 140, align: 'center'},
        {
          label: '文件名称',
          render: ({video_url, video_name}, h) => {
            return h('a', {
              attrs: {
                href: video_url,
                title: '点击查看',
                target: '_blank',
              },
              style: {
                color: '#3486EF'
              }
            }, video_name)
          }
        },
        {label: '开始时间', key: 'start_time', width: 180, align: 'center'},
        {label: '结束时间', key: 'end_time', width: 180, align: 'center'},
        {label: '创建时间', key: 'created_at', width: 160, align: 'center'},
        {label: '修改时间', key: 'updated_at', width: 160, align: 'center'},
      ],
      actions: [],
      //
      formData: {
        device_type: 'bus',
        video_url: '',
        video_name: '',
        start_time: '',
        end_time: '',
        time_range: [],
      },
      formRules: {
        video_url: [
          {required: true, message: '请上传视频', trigger: 'blur'},
        ],
        video_name: [
          {required: true, message: '请填写视频名称', trigger: 'blur'},
        ],
        time_range: [
          {required: true, message: '请选择时间', trigger: 'blur'},
        ],
      },
      form_loading: false,
      show_form_dialog: false,
    }
  },
  components: {
    PageHeader,
    PageTable
  },
  created() {

  },
  mounted() {

  },
  activated() {
    this.$refs.table && this.$refs.table.loadData()
  },
  methods: {
    handleItemActionClick(action, item) {
      let that = this
      that[action + 'Action'](item)
    },
    handleAdd() {
      let that = this
      that.formData = {
        device_type: 'bus',
        video_url: '',
        video_name: '',
        start_time: '',
        end_time: '',
        time_range: [],
      }
      that.show_form_dialog = true
    },
    handleUploadVideo(source) {
      let that = this
      const file = source.file
      console.log(file)
      let func
      // 优先通过 MIME type 判断
      if (file.type.startsWith('video/')) {
        func = uploadVideo
      } else {
        func = uploadImage
      }
      let loadingInstance = that.$loading()
      func('sensor', source.file).then(res => {
        loadingInstance.close()
        that.$message.success('操作成功')
        that.formData.video_url = res.absolute_url
      }).catch((err) => {
        console.log(err)
        loadingInstance.close()
        that.$message.error('上传失败，请重试')
      })
    },
    timeRangeChange(val) {
      if (val) {
        this.formData.start_time = val[0]
        this.formData.end_time = val[1]
      } else {
        this.formData.start_time = ''
        this.formData.end_time = ''
      }
    },
    addSubmit(formName) {
      let that = this
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.form_loading = true
          videoLogCreate(that.formData).then(() => {
            that.form_loading = false
            that.$message.success('操作成功')
            that.show_form_dialog = false
            setTimeout(() => {
              that.$refs.table && that.$refs.table.loadData()
            }, 500)
          }).catch(() => {
            that.form_loading = false
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
